/* eslint-disable react-hooks/exhaustive-deps */
import { useCallback, useEffect, useState } from "react";
import { Autocomplete, Box, TextField } from "@mui/material";
import { useTheme } from "@emotion/react";
import { useTranslation } from "react-i18next";
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import PageService from "../../services/pageService";

const cacheRtl = createCache({ key: 'muirtl', stylisPlugins: [rtlPlugin] });
const cacheLtr = createCache({ key: 'ltr' });

const PageDropdown = ({ helperText, error, setFormValues, isFilter, selectedPage, setSelectedPage, includeRemainAmount }) => {
    const theme = useTheme();
    const { t, i18n } = useTranslation();

    const [pages, setPages] = useState([]);

    useEffect(() => {
        const fetchPages = async () => {
            try {
                const data = await PageService.fetchAllWithCitiesDropdown();
                setPages(data);
            } catch (error) {
                console.error('Error fetching pages:', error);
            }
        };
        fetchPages();
    }, []);

    const getOptionLabel = useCallback(
        (option) => `${option.name || ''} ${option.phone ? `(${option.phone})` : ''}`.trim(),
        []
    );

    const renderOption = useCallback(
        (props, option) => (
            <li {...props} key={option.id}>
                {option.name || ''} {option.phone ? `(${option.phone})` : ''}
            </li>
        ),
        []
    );

    return (
        <CacheProvider value={i18n.language === 'en' ? cacheLtr : cacheRtl}>
            <Autocomplete
                options={pages}
                getOptionLabel={getOptionLabel}
                value={selectedPage}
                onChange={(event, newValue) => {
                    setSelectedPage(newValue);
                    setFormValues && setFormValues((prevValues) => ({
                        ...prevValues,
                        pageId: newValue ? newValue.id : null,
                    }));
                }}
                renderOption={renderOption}
                renderInput={(params) => (
                    <Box>
                        {
                            !isFilter && <p
                                style={{
                                    color: theme.palette.text.primary,
                                    fontSize: 13,
                                    marginTop: 24,
                                    marginBottom: 4,
                                }}
                            >
                                {t("page")}
                            </p>
                        }

                        <TextField
                            {...params}
                            variant={isFilter ? 'standard' : 'outlined'}
                            fullWidth
                            placeholder={isFilter ? t('page') : t('choosePage')}
                            error={!!error}
                            helperText={helperText}
                            InputProps={{
                                ...params.InputProps,
                                ...(isFilter ? { disableUnderline: true } : {}),
                                endAdornment: (
                                    <>
                                        {params.InputProps.endAdornment}
                                    </>
                                ),
                                style: {
                                    backgroundColor: isFilter ? 'transparent' : theme.palette.customGrey.insideInput,
                                    padding: '6px 8px',
                                },
                            }}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    '& fieldset': {
                                        borderColor: theme.palette.customGrey.borderInput,
                                    },
                                    '&:hover fieldset': {
                                        borderColor: theme.palette.customGrey.borderInput,
                                    },
                                    '&.Mui-focused fieldset': {
                                        borderColor: theme.palette.primary.main,
                                    },
                                },
                                '& .MuiInputBase-input': {
                                    color: theme.palette.text.primary,
                                    padding: '6px 8px',
                                    '&::placeholder': {
                                        fontSize: '14px',
                                        color: theme.palette.text.secondary,
                                        opacity: 1,
                                    },
                                },
                            }}
                        />
                    </Box>
                )}
            />
        </CacheProvider>
    );
}

export default PageDropdown;